import React from "react";
import { Outlet } from "react-router-dom";
import logo from "./img/logo.png";

export default function Layout() {
  const [activeSection, setActiveSection] = React.useState("hero");
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);

      const sections = ["hero", "why-now", "invest-in", "value", "investors", "founders", "contact"];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth"
      });
    }
  };

  const navItems = [
    { id: "hero", label: "Home" },
    { id: "why-now", label: "Why Now" },
    { id: "invest-in", label: "Investment Focus" },
    { id: "value", label: "Value Creation" },
    { id: "investors", label: "Investors" },
    { id: "founders", label: "Founders" },
    { id: "contact", label: "Contact" }
  ];

  return (
    <div className="min-h-screen bg-[#0B1C2C]">
      <style>{`
        :root {
          --navy-900: #0B1C2C;
          --steel-700: #2C3E50;
          --slate-500: #6B7C93;
          --signal: #24A19C;
          --secondary: #E0B422;
          --surface: #0F2437;
          --light-surface: #F5F7FA;
        }
      `}</style>

      <nav 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled 
            ? "bg-[#0B1C2C]/95 backdrop-blur-md shadow-lg border-b border-[#24A19C]/10" 
            : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <button 
              onClick={() => scrollToSection("hero")}
              className="text-2xl font-bold text-white tracking-tight hover:text-[#24A19C] transition-colors"
            >
             <img src={logo} alt="Miltech Capital" style={{width: "150px"}}/>
            </button>

            <div className="hidden md:flex items-center gap-8">
              {navItems.slice(1).map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`text-sm font-medium transition-colors relative ${
                    activeSection === item.id 
                      ? "text-[#24A19C]" 
                      : "text-[#6B7C93] hover:text-white"
                  }`}
                >
                  {item.label}
                  {activeSection === item.id && (
                    <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#24A19C]" />
                  )}
                </button>
              ))}
            </div>

            <button 
              onClick={() => scrollToSection("contact")}
              className="bg-[#24A19C] hover:bg-[#1d8a85] text-white px-6 py-2.5 rounded-lg font-medium transition-all duration-200 hover:shadow-lg hover:shadow-[#24A19C]/20"
            >
              Get in Touch
            </button>
          </div>
        </div>
      </nav>

      <Outlet />

      <footer className="bg-[#0B1C2C] border-t border-[#24A19C]/10 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Miltech Capital</h3>
              <p className="text-[#6B7C93] text-sm leading-relaxed">
                Growth capital for defence technology leaders building mission-critical solutions.
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <div className="space-y-2">
                {navItems.slice(1).map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="block text-[#6B7C93] hover:text-[#24A19C] text-sm transition-colors"
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Compliance</h4>
              <p className="text-[#6B7C93] text-sm leading-relaxed">
                EU Common Position compliant<br/>
                ITAR/EAR adherent<br/>
                ESG & human rights screening
              </p>
            </div>
          </div>
          <div className="border-t border-[#24A19C]/10 pt-8 text-center text-[#6B7C93] text-sm">
            © {new Date().getFullYear()} Miltech Capital. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}